const savedBrowserBackRedirectCounter = Number(localStorage.getItem('browserBackRedirectCounter')) || 0;
export default {
  progressivePlanAPiResponse: {},
  progressivePlanFailureAPiResponse: {},
  perkDetails: {},
  selectedPlanInfo: [],
  getfwaplansLoaded: false,
  errorNotification: false,
  scOpen: false,
  discountToggleBar: {
    isAutoPayEnabled: false,
  },
  perkPdpOverlay: {
    show: false,
  },
  termsAndConditionsOverlay: {
    show: false,
  },
  perkTermsAndConditionsOverlay: {
    show: false,
  },
  addPlanAPiResponse: {},
  autoPayOn: false,
  planAccordionState: {
    show: true,
    lastUpdated: String(new Date()),
  },
  perkDisclosureOverlay: {
    disclosureDisplayed: [],
    show: false,
    currentSpoId: '',
  },
  perkChoiceOverlay: {
    disclosureDisplayed: [],
    show: false,
    currentSpoId: '',
  },
  perkMultipleDisclosureOverlay: {
    disclosureDisplayed: [],
    show: false,
    openModals: {},
  },
  perkDuplicateOverlay: {
    disclosureDisplayed: [],
    show: false,
    currentSpoId: '',
    openModals: {},
  },
  netflixPlusPlay: false,
  fromProgressive: false,
  lqLoaded: false,
  prevToggleExplore: '',
  enableChoiceOffer: false,
  cbandStall: false,
  specialOfferRequired: false,
  planChangedAbanded: false,
  addPlanAPICalled: false,
  abandonDiscontOfferAppiled: false,
  upgradeOfferClicked: false,
  showVhdpModal: false,
  showSpecialGiftSectionBanner: false,
  isPerkUpSellAddClick: false,
  browserBackRedirectCounter : savedBrowserBackRedirectCounter,
  giftCardOfferModalClicked: false,
  giftCardOfferLinkClicked: false,
  selectedPerkBundleState: { previousSelected: '' },
  displayPerkBundleNotification: false,
  perkBundleNotification: {},
};
